import { useCourse } from "../context/CourseContext";
import GroupMemberships from "./GroupMemberships";

export default function GroupSettings() {
  const { course } = useCourse();
  return <GroupMemberships key={course._id} groupId={course._id} />;
}
